export default __webpack_public_path__ + "static/media/cashback.1de0b58f.png";